import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import GraphicEditor from 'pages/graphic-editor';
import MappingPage from 'pages/mapping';
import NodesApp from 'pages/node-interface';
import NotFound from '../components/website/errors/NotFound';
import Register from 'pages/auth/register';
import AdminManagementProtected from './AdminManagementProtected';
import PaymentSuccessProtected from './PaymentSuccessProtected';
import ProjectsLayout from './ProjectsLayout';

export default function AppAuthenticatedRoutes() {
  return (
    <Switch>
      <Route exact path="/register" component={Register} />
      <Route exact path="/">
        <Redirect to="/admin" />
      </Route>
      <Route
        path="/project/:project_id/design/new"
        component={GraphicEditor}
      />
      <Route
        path="/project/:project_id/design/:design_id"
        component={GraphicEditor}
      />
      <Route exact path="/project/:project_id/rule/new" component={NodesApp} />
      <Route
        exact
        path="/project/:project_id/rule/:rule_id"
        component={NodesApp}
      />
      <Route path="/project/:project_id/mapping/new" component={MappingPage} />
      <Route
        path="/project/:project_id/mapping/:mapping_id"
        component={MappingPage}
      />
      <Route
        path="/payment/:organizationId/"
        component={PaymentSuccessProtected}
      />
      <Route
        path="/payment-method/:organizationId/"
        component={PaymentSuccessProtected}
      />
      <Route path="/admin/:organizationId" component={AdminManagementProtected} />
      <Route path="/admin" component={AdminManagementProtected} />
      <Route path="/projects-new/:organizationId" component={ProjectsLayout} />
      <Route path="/projects-new" component={ProjectsLayout} />
      <Route component={NotFound} />
    </Switch>
  );
}
